import React from "react";
import BarChartIcon from "@mui/icons-material/BarChart";

const EmployeeStatisticsWidget = () => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex flex-col gap-4">
      <div className="flex justify-between items-center border-b pb-3">
        <h3 className="font-bold text-gray-800 flex items-center gap-2">
          <BarChartIcon className="text-emerald-500" />
          Employee Stats
        </h3>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center min-h-[150px] gap-2">
        <div className="w-full flex justify-between items-center p-3 bg-gray-50 rounded-lg">
          <span className="text-sm font-medium text-gray-600">Present Today</span>
          <span className="text-lg font-bold text-emerald-600">92%</span>
        </div>
        <div className="w-full flex justify-between items-center p-3 bg-gray-50 rounded-lg">
          <span className="text-sm font-medium text-gray-600">On Leave</span>
          <span className="text-lg font-bold text-gray-800">8%</span>
        </div>
      </div>
    </div>
  );
};

export default EmployeeStatisticsWidget;
